export class Cookies {
    protected cookies = new Map<string, string>();

    constructor(cookies: string = document.cookie) {
        cookies.split(';').forEach((cookie) => {
            const keyValuePair = cookie.split('=');

            if (keyValuePair.length === 2) {
                const [key, value] = keyValuePair;
                this.set(key.trim(), value);
            }
        });
    }

    public get(key: string): string | undefined {
        return this.cookies.get(key);
    }

    public set(key: string, value: string): void {
        if (!/^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/.test(key)) {
            throw new Error('Invalid key');
        }

        this.cookies.set(key, value);
    }
}
